import { createRouter } from "@tanstack/react-router";
import { queryClient } from "./queryClient";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 1000 * 60 * 5,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
